export default __webpack_public_path__ + "static/media/peep-19.2dd280ad.svg";